import C from '../../constants/palette';

function navigate(path) {
  window.history.pushState(null, '', path);
  window.dispatchEvent(new Event('popstate'));
  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
}

export default function SiteFooter() {
  return (
    <footer style={{ background: C.dark, color: '#fff', padding: '30px 48px 34px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
      <div style={{ maxWidth: 1280, margin: '0 auto', display: 'flex', justifyContent: 'space-between', gap: 32, alignItems: 'flex-end', flexWrap: 'wrap' }}>
        <div>
          <p style={{ fontFamily: 'Playfair Display', fontSize: 20, letterSpacing: '0.04em', marginBottom: 7 }}>KINGSTRADE</p>
          <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 11, lineHeight: 1.6 }}>Treasure collection and private acquisition service.</p>
        </div>
        <nav aria-label="Site information" style={{ display: 'flex', gap: 22, flexWrap: 'wrap' }}>
          {[
            ['/how-it-works', 'HOW IT WORKS'],
            ['/terms-and-policy', 'TERMS & POLICY'],
            ['/collection', 'EXPLORE CATALOGUE'],
          ].map(([path, label]) => (
            <button
              key={path}
              type="button"
              onClick={() => navigate(path)}
              style={{ border: 'none', background: 'none', color: 'rgba(255,255,255,0.78)', padding: 0, cursor: 'pointer', fontSize: 10, letterSpacing: '0.14em', fontWeight: 700 }}
            >
              {label}
            </button>
          ))}
        </nav>
      </div>
      <p style={{ maxWidth: 1280, margin: '24px auto 0', paddingTop: 16, borderTop: '1px solid rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.42)', fontSize: 10, letterSpacing: '0.08em' }}>
        KINGSTRADE COLLECTABLES · MEIIWE INTERNATIONAL PTE LTD
      </p>
    </footer>
  );
}
